module.exports = __webpack_public_path__ + "res/img/cl.36c525c0.png";